import React, { useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { generateWalletFundingUrl } from '../../utils/patients/generatePaymentUrl';
import useProfileStore from '../../store/patient/profileStore';

const FundWalletModal = ({ show, setShow }) => {
    const [amount, setAmount] = useState('');
    const [error, setError] = useState('');
    const {profile} = useProfileStore();

    const handleClose = () => {
        generateWalletFundingUrl(amount, profile?.email, profile?.id).then((res) => {
            if (res?.data?.status) {
            window.location.href = res?.data?.data?.authorization_url;  
            }
        }).catch((err) => {
            console.error('Error generating payment URL:', err);
        });
        setShow(false);
        setAmount(''); // Reset amount when closing
        setError(''); // Reset error when closing
    };

    const handleAmountChange = (e) => {
        const value = e.target.value;
        // Allow only numbers
        if (/^\d*$/.test(value)) {
            setAmount(value);
            // Check if amount is less than minimum
            if (value && Number(value) < 100) {
                setError('Minimum amount is ₦100');
            } else {
                setError('');
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (Number(amount) >= 100) {
            // Here you would typically make an API call to process the funding
            console.log(`Funding wallet with ₦${amount}`);
            handleClose();
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Fund Your Wallet</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Amount (₦)</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter amount (minimum ₦100)"
                            value={amount}
                            onChange={handleAmountChange}
                            isInvalid={!!error}
                        />
                        <Form.Text className="text-muted">
                            Minimum funding amount is ₦100
                        </Form.Text>
                        {error && (
                            <Form.Control.Feedback type="invalid">
                                {error}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    variant="primary" 
                    onClick={handleSubmit}
                    disabled={!amount || Number(amount) < 100}
                >
                    Fund Wallet
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FundWalletModal;